import { ILiteTradeAssetSymbol } from "./types/liteTradeReducer.t";

export const LITE_TRADE_ASSETS_CONFIG: { [name in ILiteTradeAssetSymbol | 'default' | string]?: {
    cardsAssetInfoBg: React.CSSProperties["color"],
    gradientCardsNameIconBgStart:  React.CSSProperties["color"],
    gradientCardsNameIconBgEnd:  React.CSSProperties["color"],
    gradientCardsNameIconColor?: React.CSSProperties["color"],
    gradientCardsNameIconName?: string,
}} = {
    default: {
        cardsAssetInfoBg: '#FFFFFF33',
        gradientCardsNameIconBgStart: '#E8E6A1',
        gradientCardsNameIconBgEnd: '#9DFA70',
    },
    BATUSD: {
        cardsAssetInfoBg: '#662D9133',
        gradientCardsNameIconBgStart: '#FFFFFF',
        gradientCardsNameIconBgEnd: '#662D91',
    },
    BNBUSD: {
        cardsAssetInfoBg: '#F3BA2F33',
        gradientCardsNameIconBgStart: '#FFFFFF',
        gradientCardsNameIconBgEnd: '#F3BA2F',
    },
    BCHUSD: {
        cardsAssetInfoBg: '#14A14C33',
        gradientCardsNameIconBgStart: '#FFFFFF',
        gradientCardsNameIconBgEnd: '#14A14C',
    },
    BTCUSD: {
        cardsAssetInfoBg: '#F3BA2F33',
        gradientCardsNameIconBgStart: '#FFFFFF',
        gradientCardsNameIconBgEnd: '#F3BA2F',
    },
    ADAUSD: {
        cardsAssetInfoBg: '#0033AD33',
        gradientCardsNameIconBgStart: '#FFFFFF',
        gradientCardsNameIconBgEnd: '#0033AD',
    },
    LNKUSD: {
        cardsAssetInfoBg: '#2A5ADA33',
        gradientCardsNameIconBgStart: '#FFFFFF',
        gradientCardsNameIconBgEnd: '#2A5ADA',
    },
    DSHUSD: {
        cardsAssetInfoBg: '#2573C233',
        gradientCardsNameIconBgStart: '#FFFFFF',
        gradientCardsNameIconBgEnd: '#2573C2',
    },
    DOGUSD: {
        cardsAssetInfoBg: '#BA9F3333',
        gradientCardsNameIconBgStart: '#F4ECB4',
        gradientCardsNameIconBgEnd: '#BA9F33',
    },
    DJIUSD: {
        cardsAssetInfoBg: '#0289CF33',
        gradientCardsNameIconBgStart: '#FFFFFF',
        gradientCardsNameIconBgEnd: '#0289CF',
    },
    EOSUSD: {
        cardsAssetInfoBg: '#696F8333',
        gradientCardsNameIconBgStart: '#FFFFFF',
        gradientCardsNameIconBgEnd: '#696F83',
    },
    ETCUSD: {
        cardsAssetInfoBg: '#1E994F33',
        gradientCardsNameIconBgStart: '#FFFFFF',
        gradientCardsNameIconBgEnd: '#1E994F',
    },
    ETHUSD: {
        cardsAssetInfoBg: '#ECEFF033',
        gradientCardsNameIconBgStart: '#FFFFFF',
        gradientCardsNameIconBgEnd: '#303131',
    },
    FILUSD: {
        cardsAssetInfoBg: '#0090FF33',
        gradientCardsNameIconBgStart: '#FFFFFF',
        gradientCardsNameIconBgEnd: '#0090FF',
    },
    IOTUSD: {
        cardsAssetInfoBg: '#FFFFFF33',
        gradientCardsNameIconBgStart: '#FFFFFF',
        gradientCardsNameIconBgEnd: '#000000',
    },
    LTCUSD: {
        cardsAssetInfoBg: '#3D5D9833',
        gradientCardsNameIconBgStart: '#FFFFFF',
        gradientCardsNameIconBgEnd: '#3D5D98',
    },
    MKRUSD: {
        cardsAssetInfoBg: '#56B2A333',
        gradientCardsNameIconBgStart: '#FFFFFF',
        gradientCardsNameIconBgEnd: '#56B2A3',
    },
    XMRUSD: {
        cardsAssetInfoBg: '#F2682233',
        gradientCardsNameIconBgStart: '#4D4D4D',
        gradientCardsNameIconBgEnd: '#F26822',
        gradientCardsNameIconColor: '#FFFFFFF2',
    },
    NDXUSD: {
        cardsAssetInfoBg: '#0289CF33',
        gradientCardsNameIconBgStart: '#FFFFFF',
        gradientCardsNameIconBgEnd: '#0289CF',
    },
    NGCUSD: {
        cardsAssetInfoBg: '#D32F2F33',
        gradientCardsNameIconBgStart: '#FFFFFF',
        gradientCardsNameIconBgEnd: '#D32F2F',
    },
    NEOUSD: {
        cardsAssetInfoBg: '#72AB4533',
        gradientCardsNameIconBgStart: '#FFFFFF',
        gradientCardsNameIconBgEnd: '#72AB45',
    },
    NIKJPY: {
        cardsAssetInfoBg: '#FFFFFF33',
        gradientCardsNameIconBgStart: '#FFFFFF',
        gradientCardsNameIconBgEnd: '#131416',
    },
    BRNUSD: {
        cardsAssetInfoBg: '#FFFFFF33',
        gradientCardsNameIconBgStart: '#FFFFFF',
        gradientCardsNameIconBgEnd: '#131416',
    },
    WTIUSD: {
        cardsAssetInfoBg: '#FFFFFF33',
        gradientCardsNameIconBgStart: '#FFFFFF',
        gradientCardsNameIconBgEnd: '#131416',
    },
    OMGUSD: {
        cardsAssetInfoBg: '#1A53F033',
        gradientCardsNameIconBgStart: '#1A53F0',
        gradientCardsNameIconBgEnd: '#FFFFFF',
        gradientCardsNameIconColor: '#FFFFFFF2',
    },
    XPDUSD: {
        cardsAssetInfoBg: '#F2ECE533',
        gradientCardsNameIconBgStart: '#DCE0EF',
        gradientCardsNameIconBgEnd: '#C0C5D8',
        gradientCardsNameIconName: 'XPDUSDwidget',
    },
    XPTUSD: {
        cardsAssetInfoBg: '#F2ECE533',
        gradientCardsNameIconBgStart: '#F2ECE5',
        gradientCardsNameIconBgEnd: '#D9CDC1',
        gradientCardsNameIconName: 'XPTUSDwidget',
    },
    DOTUSD: {
        cardsAssetInfoBg: '#E6007A33',
        gradientCardsNameIconBgStart: '#FFFFFF',
        gradientCardsNameIconBgEnd: '#E6007A',
    },
    MTCUSD: {
        cardsAssetInfoBg: '#8247E533',
        gradientCardsNameIconBgStart: '#FFFFFF',
        gradientCardsNameIconBgEnd: '#8247E5',
    },
    XRPUSD: {
        cardsAssetInfoBg: '#FFFFFF33',
        gradientCardsNameIconBgStart: '#FFFFFF',
        gradientCardsNameIconBgEnd: '#23292F',
    },
    SPXUSD: {
        cardsAssetInfoBg: '#DF003833',
        gradientCardsNameIconBgStart: '#FFFFFF',
        gradientCardsNameIconBgEnd: '#DF0038',
    },
    XAGEUR: {
        cardsAssetInfoBg: '#E3E4E533',
        gradientCardsNameIconBgStart: '#E3E4E5',
        gradientCardsNameIconBgEnd: '#CFD3D6',
        gradientCardsNameIconName: 'XAGEURwidget',
    },
    XAGUSD: {
        cardsAssetInfoBg: '#E3E4E533',
        gradientCardsNameIconBgStart: '#E3E4E5',
        gradientCardsNameIconBgEnd: '#CFD3D6',
        gradientCardsNameIconName: 'XAGUSDwidget',
    },
    SOLUSD: {
        cardsAssetInfoBg: '#14EBAB33',
        gradientCardsNameIconBgStart: '#14EBAB',
        gradientCardsNameIconBgEnd: '#7885D5',
    },
    XLMUSD: {
        cardsAssetInfoBg: '#FFFFFF33',
        gradientCardsNameIconBgStart: '#FFFFFF',
        gradientCardsNameIconBgEnd: '#101215',
    },
    TRXUSD: {
        cardsAssetInfoBg: '#FFFFFF33',
        gradientCardsNameIconBgStart: '#FFFFFF',
        gradientCardsNameIconBgEnd: '#696F83',
    },
    FTSGBP: {
        cardsAssetInfoBg: '#BE2E3333',
        gradientCardsNameIconBgStart: '#FFFFFF',
        gradientCardsNameIconBgEnd: '#BE2E33',
    },
    UNIUSD: {
        cardsAssetInfoBg: '#FF007A33',
        gradientCardsNameIconBgStart: '#FFFFFF',
        gradientCardsNameIconBgEnd: '#FF007A',
    },
    ZECUSD: {
        cardsAssetInfoBg: '#FFE25F33',
        gradientCardsNameIconBgStart: '#FFE25F',
        gradientCardsNameIconBgEnd: '#1C2025',
    },
    ADBE: {
        cardsAssetInfoBg: '#ED1C2433',
        gradientCardsNameIconBgStart: '#FFFFFF',
        gradientCardsNameIconBgEnd: '#ED1C24',
    },
    AA: {
        cardsAssetInfoBg: '#1450A133',
        gradientCardsNameIconBgStart: '#FFFFFF',
        gradientCardsNameIconBgEnd: '#1450A1',
    },
    BABA: {
        cardsAssetInfoBg: '#DB764033',
        gradientCardsNameIconBgStart: '#FFFFFF',
        gradientCardsNameIconBgEnd: '#DB7640',
    },
    GOOGL: {
        cardsAssetInfoBg: '#4285F433',
        gradientCardsNameIconBgStart: '#FFFFFF',
        gradientCardsNameIconBgEnd: '#4285F4',
    },
    AMZN: {
        cardsAssetInfoBg: '#FF990033',
        gradientCardsNameIconBgStart: '#FFFFFF',
        gradientCardsNameIconBgEnd: '#FF9900',
    },
    AXP: {
        cardsAssetInfoBg: '#0077A633',
        gradientCardsNameIconBgStart: '#FFFFFF',
        gradientCardsNameIconBgEnd: '#0077A6',
    },
    AAPL: {
        cardsAssetInfoBg: '#FFFFFF33',
        gradientCardsNameIconBgStart: '#FFFFFF',
        gradientCardsNameIconBgEnd: '#696F83',
    },
    T: {
        cardsAssetInfoBg: '#00A8E033',
        gradientCardsNameIconBgStart: '#FFFFFF',
        gradientCardsNameIconBgEnd: '#00A8E0',
    },
    BIDU: {
        cardsAssetInfoBg: '#2E7DE233',
        gradientCardsNameIconBgStart: '#FFFFFF',
        gradientCardsNameIconBgEnd: '#2E7DE2',
    },
    BAC: {
        cardsAssetInfoBg: '#2267AD33',
        gradientCardsNameIconBgStart: '#FFFFFF',
        gradientCardsNameIconBgEnd: '#2267AD',
    },
    BA: {
        cardsAssetInfoBg: '#2E7DE233',
        gradientCardsNameIconBgStart: '#FFFFFF',
        gradientCardsNameIconBgEnd: '#2E7DE2',
    },
    AVGO: {
        cardsAssetInfoBg: '#CC242733',
        gradientCardsNameIconBgStart: '#FFFFFF',
        gradientCardsNameIconBgEnd: '#C9313B',
    },
    COF: {
        cardsAssetInfoBg: '#CC242733',
        gradientCardsNameIconBgStart: '#FFFFFF',
        gradientCardsNameIconBgEnd: '#CC2427',
    },
    CAT: {
        cardsAssetInfoBg: '#F6D33C33',
        gradientCardsNameIconBgStart: '#FFFFFF',
        gradientCardsNameIconBgEnd: '#F6D33C',
    },
    CVX: {
        cardsAssetInfoBg: '#10599C33',
        gradientCardsNameIconBgStart: '#FFFFFF',
        gradientCardsNameIconBgEnd: '#10599C',
    },
    CSCO: {
        cardsAssetInfoBg: '#10599C33',
        gradientCardsNameIconBgStart: '#FFFFFF',
        gradientCardsNameIconBgEnd: '#049FD9',
    },
    C: {
        cardsAssetInfoBg: '#10599033',
        gradientCardsNameIconBgStart: '#FFFFFF',
        gradientCardsNameIconBgEnd: '#0158A6',
    },
    KO: {
        cardsAssetInfoBg: '#B0002033',
        gradientCardsNameIconBgStart: '#FFFFFF',
        gradientCardsNameIconBgEnd: '#B00020',
    },
    EBAY: {
        cardsAssetInfoBg: '#FFFFFF33',
        gradientCardsNameIconBgStart: '#FFFFFF',
        gradientCardsNameIconBgEnd: '#8DC3FF',
    },
    EA: {
        cardsAssetInfoBg: '#EC564F33',
        gradientCardsNameIconBgStart: '#EC564F',
        gradientCardsNameIconBgEnd: '#FFFFFF',
    },
    XOM: {
        cardsAssetInfoBg: '#FFFFFF33',
        gradientCardsNameIconBgStart: '#FFFFFF',
        gradientCardsNameIconBgEnd: '#CF4037',
    },
    META: {
        cardsAssetInfoBg: '#FFFFFF33',
        gradientCardsNameIconBgStart: '#FFFFFF',
        gradientCardsNameIconBgEnd: '#0081FA',
    },
    RACE: {
        cardsAssetInfoBg: '#FFF20033',
        gradientCardsNameIconBgStart: '#FFF200',
        gradientCardsNameIconBgEnd: '#FFC700',
    },
    F: {
        cardsAssetInfoBg: '#FFFFFF33',
        gradientCardsNameIconBgStart: '#FFFFFF',
        gradientCardsNameIconBgEnd: '#425E99',
    },
    GE: {
        cardsAssetInfoBg: '#3B73B933',
        gradientCardsNameIconBgStart: '#FFFFFF',
        gradientCardsNameIconBgEnd: '#3B73B9',
    },
    GM: {
        cardsAssetInfoBg: '#22559E33',
        gradientCardsNameIconBgStart: '#FFFFFF',
        gradientCardsNameIconBgEnd: '#22559E',
    },
    GOPRO: {
        cardsAssetInfoBg: '#00AEEF33',
        gradientCardsNameIconBgStart: '#00AEEF',
        gradientCardsNameIconBgEnd: '#005DAC',
    },
    HPQ: {
        cardsAssetInfoBg: '#01529433',
        gradientCardsNameIconBgStart: '#00AEEF',
        gradientCardsNameIconBgEnd: '#015294',
    },
    HD: {
        cardsAssetInfoBg: '#EE712533',
        gradientCardsNameIconBgStart: '#EE7125',
        gradientCardsNameIconBgEnd: '#FFFFFF',
    },
    INTC: {
        cardsAssetInfoBg: '#0289CF33',
        gradientCardsNameIconBgStart: '#0289CF',
        gradientCardsNameIconBgEnd: '#FFFFFF',
    },
    IBM: {
        cardsAssetInfoBg: '#2E7DE233',
        gradientCardsNameIconBgStart: '#2E7DE2',
        gradientCardsNameIconBgEnd: '#FFFFFF',
    },
    JNJ: {
        cardsAssetInfoBg: '#EC030333',
        gradientCardsNameIconBgStart: '#EC0303',
        gradientCardsNameIconBgEnd: '#FFFFFF',
        gradientCardsNameIconColor: '#FFFFFFF2',

    },
    JPM: {
        cardsAssetInfoBg: '#48516D33',
        gradientCardsNameIconBgStart: '#48516D',
        gradientCardsNameIconBgEnd: '#FFFFFF',
        gradientCardsNameIconColor: '#FFFFFFF2',
    },
    MCD: {
        cardsAssetInfoBg: '#FFC30033',
        gradientCardsNameIconBgStart: '#D02E35',
        gradientCardsNameIconBgEnd: '#FFC300',
        gradientCardsNameIconColor: '#FFFFFFF2',
    },
    MRK: {
        cardsAssetInfoBg: '#1B9B9433',
        gradientCardsNameIconBgStart: '#FFFFFF',
        gradientCardsNameIconBgEnd: '#1B9B94',
    },
    MSFT: {
        cardsAssetInfoBg: '#00ADEF33',
        gradientCardsNameIconBgStart: '#FFFFFF',
        gradientCardsNameIconBgEnd: '#00ADEF',
    },
    NFLX: {
        cardsAssetInfoBg: '#D81F2633',
        gradientCardsNameIconBgStart: '#FFFFFF',
        gradientCardsNameIconBgEnd: '#D81F26',
    },
    NKE: {
        cardsAssetInfoBg: '#696F8333',
        gradientCardsNameIconBgStart: '#FFFFFF',
        gradientCardsNameIconBgEnd: '#696F83',
    },
    NVDA: {
        cardsAssetInfoBg: '#CDE91333',
        gradientCardsNameIconBgStart: '#696F83',
        gradientCardsNameIconBgEnd: '#CDE913',
    },
    ORCL: {
        cardsAssetInfoBg: '#EA1B2233',
        gradientCardsNameIconBgStart: '#FFFFFF',
        gradientCardsNameIconBgEnd: '#EA1B22',
    },
    PYPL: {
        cardsAssetInfoBg: '#179BD733',
        gradientCardsNameIconBgStart: '#179BD7',
        gradientCardsNameIconBgEnd: '#253B80',
    },
    PEP: {
        cardsAssetInfoBg: '#25539833',
        gradientCardsNameIconBgStart: '#FFFFFF',
        gradientCardsNameIconBgEnd: '#255398',
    },
    PG: {
        cardsAssetInfoBg: '#003CAE33',
        gradientCardsNameIconBgStart: '#FFFFFF',
        gradientCardsNameIconBgEnd: '#003CAE',
    },
    QCOM: {
        cardsAssetInfoBg: '#3B5FAB33',
        gradientCardsNameIconBgStart: '#FFFFFF',
        gradientCardsNameIconBgEnd: '#3B5FAB',
    },
    SBUX: {
        cardsAssetInfoBg: '#0C7A3833',
        gradientCardsNameIconBgStart: '#FFFFFF',
        gradientCardsNameIconBgEnd: '#0C7A38',
    },
    TSLA: {
        cardsAssetInfoBg: '#B0002033',
        gradientCardsNameIconBgStart: '#B00020',
        gradientCardsNameIconBgEnd: '#FFFFFF',
        gradientCardsNameIconColor: '#FFFFFFF2',
    },
    VZ: {
        cardsAssetInfoBg: '#D81F2633',
        gradientCardsNameIconBgStart: '#D81F26',
        gradientCardsNameIconBgEnd: '#FFFFFF',
        gradientCardsNameIconColor: '#FFFFFFF2',
    },
    V: {
        cardsAssetInfoBg: '#0158A633',
        gradientCardsNameIconBgStart: '#0158A6',
        gradientCardsNameIconBgEnd: '#FFFFFF',
        gradientCardsNameIconColor: '#FFFFFFF2',
    },
    WMT: {
        cardsAssetInfoBg: '#1A75CF33',
        gradientCardsNameIconBgStart: '#1A75CF',
        gradientCardsNameIconBgEnd: '#FDBB30',
        gradientCardsNameIconColor: '#FFFFFFF2',
    },
    DIS: {
        cardsAssetInfoBg: '#5F2EE233',
        gradientCardsNameIconBgStart: '#5F2EE2',
        gradientCardsNameIconBgEnd: '#FFFFFF',
        gradientCardsNameIconColor: '#FFFFFFF2',
    },
    XAUEUR: {
        cardsAssetInfoBg: '#F3D55B33',
        gradientCardsNameIconBgStart: '#F3D55B',
        gradientCardsNameIconBgEnd: '#C39B00',
        gradientCardsNameIconName: 'XAUEURwidget',
    },
    XAUUSD: {
        cardsAssetInfoBg: '#F3D55B33',
        gradientCardsNameIconBgStart: '#F3D55B',
        gradientCardsNameIconBgEnd: '#C39B00',
        gradientCardsNameIconName: 'XAUUSDwidget',
    },
    EGLUSD: {
        cardsAssetInfoBg: '#23F7DD33',
        gradientCardsNameIconBgStart: '#FFFFFF',
        gradientCardsNameIconBgEnd: '#23F7DD',
    },
    PEPUSD: {
        cardsAssetInfoBg: '#DFCF7A33',
        gradientCardsNameIconBgStart: '#FFFFFF',
        gradientCardsNameIconBgEnd: '#DFCF7A',
    },
    RNDUSD: {
        cardsAssetInfoBg: '#CF101133',
        gradientCardsNameIconBgStart: '#CF1011',
        gradientCardsNameIconBgEnd: '#FFFFFF',
    },
    SHBUSD: {
        cardsAssetInfoBg: '#FFA40933',
        gradientCardsNameIconBgStart: '#FFFFFF',
        gradientCardsNameIconBgEnd: '#FFA409',
    },
    TONUSD: {
        cardsAssetInfoBg: '#0088CC33',
        gradientCardsNameIconBgStart: '#0088CC',
        gradientCardsNameIconBgEnd: '#FFFFFF',
    },
    AAVUSD: {
        cardsAssetInfoBg: '#B6519F33',
        gradientCardsNameIconBgStart: '#B6519F',
        gradientCardsNameIconBgEnd: '#FFFFFF',
    },
    ALGUSD: {
        cardsAssetInfoBg: '#FFFFFF33',
        gradientCardsNameIconBgStart: '#373737',
        gradientCardsNameIconBgEnd: '#FFFFFF',
    },
    APTUSD: {
        cardsAssetInfoBg: '#FFFFFF33',
        gradientCardsNameIconBgStart: '#373737',
        gradientCardsNameIconBgEnd: '#FFFFFF',
    },
    ARWUSD: {
        cardsAssetInfoBg: '#FFFFFF33',
        gradientCardsNameIconBgStart: '#FFFFFF',
        gradientCardsNameIconBgEnd: '#222326',
    },
    ATMUSD: {
        cardsAssetInfoBg: '#FFFFFF33',
        gradientCardsNameIconBgStart: '#6F7390',
        gradientCardsNameIconBgEnd: '#FFFFFF',
    },
    AVAUSD: {
        cardsAssetInfoBg: '#FFFFFF33',
        gradientCardsNameIconBgStart: '#E84142',
        gradientCardsNameIconBgEnd: '#FFFFFF',
    },
    AXSUSD: {
        cardsAssetInfoBg: '#0055D533',
        gradientCardsNameIconBgStart: '#0055D5',
        gradientCardsNameIconBgEnd: '#FFFFFF',
    },
    BARUSD: {
        cardsAssetInfoBg: '#FFFFFF33',
        gradientCardsNameIconBgStart: '#222326',
        gradientCardsNameIconBgEnd: '#FFFFFF',
    },
    CHZUSD: {
        cardsAssetInfoBg: '#FF125633',
        gradientCardsNameIconBgStart: '#FF1256',
        gradientCardsNameIconBgEnd: '#FFFFFF',
    },
    FETUSD: {
        cardsAssetInfoBg: '#D9D9D933',
        gradientCardsNameIconBgStart: '#202944',
        gradientCardsNameIconBgEnd: '#FFFFFF',
    },
    FLWUSD: {
        cardsAssetInfoBg: '#00EF8B33',
        gradientCardsNameIconBgStart: '#00EF8B',
        gradientCardsNameIconBgEnd: '#FFFFFF',
    },
    FTMUSD: {
        cardsAssetInfoBg: '#13B5EC33',
        gradientCardsNameIconBgStart: '#13B5EC',
        gradientCardsNameIconBgEnd: '#FFFFFF',
    },
    GALUSD: {
        cardsAssetInfoBg: '#FFFFFF33',
        gradientCardsNameIconBgStart: '#3C3D3E',
        gradientCardsNameIconBgEnd: '#FFFFFF',
    },
    GRTUSD: {
        cardsAssetInfoBg: '#6747ED33',
        gradientCardsNameIconBgStart: '#6747ED',
        gradientCardsNameIconBgEnd: '#FFFFFF',
    },
    ICPUSD: {
        cardsAssetInfoBg: '#EE1F7A33',
        gradientCardsNameIconBgStart: '#EE1F7A',
        gradientCardsNameIconBgEnd: '#FCB13C',
    },
    IMXUSD: {
        cardsAssetInfoBg: '#17B5CB33',
        gradientCardsNameIconBgStart: '#17B5CB',
        gradientCardsNameIconBgEnd: '#FFFFFF',
    },
    NERUSD: {
        cardsAssetInfoBg: '#FFFFFF33',
        gradientCardsNameIconBgStart: '#3C3D3E',
        gradientCardsNameIconBgEnd: '#FFFFFF',
    },
    SANUSD: {
        cardsAssetInfoBg: '#018FFB33',
        gradientCardsNameIconBgStart: '#018FFB',
        gradientCardsNameIconBgEnd: '#FFFFFF',
    },
    TETUSD: {
        cardsAssetInfoBg: '#2ABFDF33',
        gradientCardsNameIconBgStart: '#2ABFDF',
        gradientCardsNameIconBgEnd: '#2DDDC4',
    },
    VECUSD: {
        cardsAssetInfoBg: '#82BE0033',
        gradientCardsNameIconBgStart: '#82BE00',
        gradientCardsNameIconBgEnd: '#FFFFFF',
    },
    AIG: {
        cardsAssetInfoBg: '#00A4E433',
        gradientCardsNameIconBgStart: '#00A4E4',
        gradientCardsNameIconBgEnd: '#FFFFFF',
    },
    FDX: {
        cardsAssetInfoBg: '#FF590033',
        gradientCardsNameIconBgStart: '#461B87',
        gradientCardsNameIconBgEnd: '#FF5900',
    },
    GS: {
        cardsAssetInfoBg: '#7399C633',
        gradientCardsNameIconBgStart: '#7399C6',
        gradientCardsNameIconBgEnd: '#FFFFFF',
    },
    H: {
        cardsAssetInfoBg: '#4B77A933',
        gradientCardsNameIconBgStart: '#4B77A9',
        gradientCardsNameIconBgEnd: '#FFFFFF',
    },
    ING: {
        cardsAssetInfoBg: '#FF620033',
        gradientCardsNameIconBgStart: '#FF6200',
        gradientCardsNameIconBgEnd: '#FFFFFF',
    },
    MA: {
        cardsAssetInfoBg: '#FF4E6233',
        gradientCardsNameIconBgStart: '#FF4E62',
        gradientCardsNameIconBgEnd: '#F79E1B',
    },
    MAR: {
        cardsAssetInfoBg: '#C6003D33',
        gradientCardsNameIconBgStart: '#C6003D',
        gradientCardsNameIconBgEnd: '#FFFFFF',
    },
    MMM: {
        cardsAssetInfoBg: '#FF000033',
        gradientCardsNameIconBgStart: '#FF0000',
        gradientCardsNameIconBgEnd: '#FFFFFF',
    },
    A: {
        cardsAssetInfoBg: '#008FFE33',
        gradientCardsNameIconBgStart: '#008FFE',
        gradientCardsNameIconBgEnd: '#FFFFFF',
    },
    AAL: {
        cardsAssetInfoBg: '#CC342833',
        gradientCardsNameIconBgStart: '#28A6EC',
        gradientCardsNameIconBgEnd: '#FE5F55',
    },
    ABNB: {
        cardsAssetInfoBg: '#FF385C33',
        gradientCardsNameIconBgStart: '#FF385C',
        gradientCardsNameIconBgEnd: '#FFFFFF',
    },
    AMD: {
        cardsAssetInfoBg: '#FFFFFF33',
        gradientCardsNameIconBgStart: '#525458',
        gradientCardsNameIconBgEnd: '#FFFFFF',
    },
    BKNG: {
        cardsAssetInfoBg: '#00AEEF33',
        gradientCardsNameIconBgStart: '#00AEEF',
        gradientCardsNameIconBgEnd: '#FFFFFF',
    },
    COIN: {
        cardsAssetInfoBg: '#0052FF33',
        gradientCardsNameIconBgStart: '#0052FF',
        gradientCardsNameIconBgEnd: '#FFFFFF',
    },
    DLPN: {
        cardsAssetInfoBg: '#C2E4F133',
        gradientCardsNameIconBgStart: '#0064A4',
        gradientCardsNameIconBgEnd: '#C2E4F1',
    },
    DPZ: {
        cardsAssetInfoBg: '#00649133',
        gradientCardsNameIconBgStart: '#006491',
        gradientCardsNameIconBgEnd: '#FFFFFF',
    },
    EXPE: {
        cardsAssetInfoBg: '#FFFFFF33',
        gradientCardsNameIconBgStart: '#1212FF',
        gradientCardsNameIconBgEnd: '#FFFFFF',
    },
    FNKO: {
        cardsAssetInfoBg: '#0276E533',
        gradientCardsNameIconBgStart: '#0276E5',
        gradientCardsNameIconBgEnd: '#FFFFFF',
    },
    GTLB: {
        cardsAssetInfoBg: '#FCA32533',
        gradientCardsNameIconBgStart: '#E34329',
        gradientCardsNameIconBgEnd: '#FCA325',
    },
    HOG: {
        cardsAssetInfoBg: '#F8670033',
        gradientCardsNameIconBgStart: '#F86700',
        gradientCardsNameIconBgEnd: '#FFFFFF',
    },
    HON: {
        cardsAssetInfoBg: '#DE1E3433',
        gradientCardsNameIconBgStart: '#DE1E34',
        gradientCardsNameIconBgEnd: '#FFFFFF',
    },
    HOOD: {
        cardsAssetInfoBg: '#00C80533',
        gradientCardsNameIconBgStart: '#00C805',
        gradientCardsNameIconBgEnd: '#FFFFFF',
    },
    LLY: {
        cardsAssetInfoBg: '#ED1D2433',
        gradientCardsNameIconBgStart: '#ED1D24',
        gradientCardsNameIconBgEnd: '#FFFFFF',
    },
    LVS: {
        cardsAssetInfoBg: '#7A582733',
        gradientCardsNameIconBgStart: '#7A5827',
        gradientCardsNameIconBgEnd: '#FFFFFF',
    },
    MAT: {
        cardsAssetInfoBg: '#FE121D33',
        gradientCardsNameIconBgStart: '#FE121D',
        gradientCardsNameIconBgEnd: '#FFFFFF',
    },
    MI: {
        cardsAssetInfoBg: '#D1301D33',
        gradientCardsNameIconBgStart: '#D1301D',
        gradientCardsNameIconBgEnd: '#FFFFFF',
    },
    MRVL: {
        cardsAssetInfoBg: '#FFFFFF33',
        gradientCardsNameIconBgStart: '#8691A2',
        gradientCardsNameIconBgEnd: '#FFFFFF',
    },
    NDAQ: {
        cardsAssetInfoBg: '#61CCF933',
        gradientCardsNameIconBgStart: '#61CCF9',
        gradientCardsNameIconBgEnd: '#FFFFFF',
    },
    NET: {
        cardsAssetInfoBg: '#F8AD3F33',
        gradientCardsNameIconBgStart: '#F48120',
        gradientCardsNameIconBgEnd: '#F8AD3F',
    },
    PLBY: {
        cardsAssetInfoBg: '#E3BF9D33',
        gradientCardsNameIconBgStart: '#E3BF9D',
        gradientCardsNameIconBgEnd: '#FFFFFF',
    },
    SPOT: {
        cardsAssetInfoBg: '#00D84D33',
        gradientCardsNameIconBgStart: '#00D84D',
        gradientCardsNameIconBgEnd: '#FFFFFF',
    },
    TRIP: {
        cardsAssetInfoBg: '#34E0A133',
        gradientCardsNameIconBgStart: '#8CEDCA',
        gradientCardsNameIconBgEnd: '#FFFFFF',
    },
    UAL: {
        cardsAssetInfoBg: '#005DAA33',
        gradientCardsNameIconBgStart: '#42AAFF',
        gradientCardsNameIconBgEnd: '#FFFFFF',
    },
    UBER: {
        cardsAssetInfoBg: '#FFFFFF33',
        gradientCardsNameIconBgStart: '#A3ABB7',
        gradientCardsNameIconBgEnd: '#FFFFFF',
    },
    UNH: {
        cardsAssetInfoBg: '#EFB02933',
        gradientCardsNameIconBgStart: '#EFB029',
        gradientCardsNameIconBgEnd: '#FFFFFF',
    },
    WFC: {
        cardsAssetInfoBg: '#FCC60A33',
        gradientCardsNameIconBgStart: '#FCC60A',
        gradientCardsNameIconBgEnd: '#FFFFFF',
    },
    WKHS: {
        cardsAssetInfoBg: '#F93B1D33',
        gradientCardsNameIconBgStart: '#F93B1D',
        gradientCardsNameIconBgEnd: '#FFFFFF',
    },
    AUDCAD: generateForexConfig('AUDCAD'),
    AUDCHF: generateForexConfig('AUDCHF'),
    AUDJPY: generateForexConfig('AUDJPY'),
    AUDNZD: generateForexConfig('AUDNZD'),
    AUDUSD: generateForexConfig('AUDUSD'),
    CADCHF: generateForexConfig('CADCHF'),
    CADJPY: generateForexConfig('CADJPY'),
    CHFJPY: generateForexConfig('CHFJPY'),
    CHFSGD: generateForexConfig('CHFSGD'),
    EURAUD: generateForexConfig('EURAUD'),
    EURCAD: generateForexConfig('EURCAD'),
    EURCHF: generateForexConfig('EURCHF'),
    EURGBP: generateForexConfig('EURGBP'),
    EURHKD: generateForexConfig('EURHKD'),
    EURJPY: generateForexConfig('EURJPY'),
    EURNOK: generateForexConfig('EURNOK'),
    EURNZD: generateForexConfig('EURNZD'),
    EURSEK: generateForexConfig('EURSEK'),
    EURSGD: generateForexConfig('EURSGD'),
    EURUSD: generateForexConfig('EURUSD'),
    EURZAR: generateForexConfig('EURZAR'),
    GBPAUD: generateForexConfig('GBPAUD'),
    GBPCAD: generateForexConfig('GBPCAD'),
    GBPCHF: generateForexConfig('GBPCHF'),
    GBPDKK: generateForexConfig('GBPDKK'),
    GBPJPY: generateForexConfig('GBPJPY'),
    GBPNOK: generateForexConfig('GBPNOK'),
    GBPNZD: generateForexConfig('GBPNZD'),
    GBPSEK: generateForexConfig('GBPSEK'),
    GBPSGD: generateForexConfig('GBPSGD'),
    GBPUSD: generateForexConfig('GBPUSD'),
    NZDCAD: generateForexConfig('NZDCAD'),
    NZDCHF: generateForexConfig('NZDCHF'),
    NZDJPY: generateForexConfig('NZDJPY'),
    NZDSGD: generateForexConfig('NZDSGD'),
    NZDUSD: generateForexConfig('NZDUSD'),
    USDCAD: generateForexConfig('USDCAD'),
    USDCHF: generateForexConfig('USDCHF'),
    USDCNH: generateForexConfig('USDCNH'),
    USDCZK: generateForexConfig('USDCZK'),
    USDDKK: generateForexConfig('USDDKK'),
    USDHKD: generateForexConfig('USDHKD'),
    USDJPY: generateForexConfig('USDJPY'),
    USDMXN: generateForexConfig('USDMXN'),
    USDNOK: generateForexConfig('USDNOK'),
    USDSEK: generateForexConfig('USDSEK'),
    USDSGD: generateForexConfig('USDSGD'),
    USDZAR: generateForexConfig('USDZAR'),
} as const;

function generateForexConfig(name: ILiteTradeAssetSymbol) {
    return {
        cardsAssetInfoBg: '#FFFFFF33',
        gradientCardsNameIconBgStart: '#FFF',
        gradientCardsNameIconBgEnd: '#3275F5',
        gradientCardsNameIconName: `${name}widget`,
    }
}
